module.exports = __webpack_public_path__ + "static/media/mo.1f249f51.svg";